function cov_j2gt43t9h() {
  var path = "/app/src/utils/check-installments-count.tsx";
  var hash = "435b2feafcb5413eb47b3a580100e44603641ebc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/check-installments-count.tsx",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 38
        },
        end: {
          line: 7,
          column: 3
        }
      },
      "1": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 7,
          column: 3
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 38
          },
          end: {
            line: 3,
            column: 39
          }
        },
        loc: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 7,
            column: 3
          }
        },
        line: 4
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "435b2feafcb5413eb47b3a580100e44603641ebc"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_j2gt43t9h = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_j2gt43t9h();
import { createNormalizeCheckingNumber } from 'src/utils/create-normalize-checking-number';
cov_j2gt43t9h().s[0]++;
export var checkInstallmentsCount = function checkInstallmentsCount(InstallmentsCountByDefault) {
  cov_j2gt43t9h().f[0]++;
  cov_j2gt43t9h().s[1]++;
  return createNormalizeCheckingNumber("Installments count argument is not a number. Tabby widget will be use a default price value ".concat(InstallmentsCountByDefault), InstallmentsCountByDefault);
};